export function ensureKebabCase(str: string): string {
  // 如果已经是 kebab-case（即包含小写字母和中划线），不做处理
  if (/^[a-z0-9\-]+$/.test(str)) {
    return str
  }

  return (
    str
      // 大小写断词，如 aB -> a-B
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      // 连续大写断词，如 ABc -> A-Bc
      .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
      // 数字和字母断词，如 a2b -> a-2-b
      .replace(/([a-zA-Z])([0-9])/g, '$1-$2') // 字母后接数字
      .replace(/([0-9])([a-zA-Z])/g, '$1-$2') // 数字后接字母
      .toLowerCase()
  )
}

export function kebabToPascalCase(str: string): string {
  return str
    .split('-') // 按连字符分割成数组
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1), // 每个单词首字母大写
    )
    .join('') // 合并成字符串
}

export function logFileSystemTreeStructure(tree: any, prefix = '', label = '') {
  if (!tree || typeof tree !== 'object') {
    console.log(`${prefix}${label}[invalid tree]`)
    return
  }

  if (label) {
    console.log(`${prefix}${label}/`)
    prefix += '  '
  }

  const entries = Object.entries(tree)
  entries.forEach(([name, node], index) => {
    const isLast = index === entries.length - 1
    const currentPrefix = prefix + (isLast ? '└── ' : '├── ')
    const nextPrefix = prefix + (isLast ? '    ' : '│   ')

    if (node && typeof node === 'object' && node !== null) {
      if (
        'file' in node &&
        node.file &&
        typeof node.file === 'object' &&
        node.file !== null &&
        'contents' in node.file
      ) {
        const size =
          typeof node.file.contents === 'string'
            ? `(${node.file.contents.length} chars)`
            : '(unknown size)'
        console.log(`${currentPrefix}${name} ${size}`)
      } else if ('directory' in node && node.directory) {
        console.log(`${currentPrefix}${name}/`)
        logFileSystemTreeStructure(node.directory, nextPrefix)
      } else {
        console.log(`${currentPrefix}${name} [unknown type]`)
      }
    } else {
      console.log(`${currentPrefix}${name} [invalid node]`)
    }
  })
}
